import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddProductModal } from "./AddProductModal";
import { Navbar } from "./Navbar";
import Products from "./Products";
import { useAuth } from "../Context/AuthContext";
import AddVariantModal from "./AddVariantModal";
import Orders from "./Orders";
import Alert from "./Alert";
import PromoCode from "./PromoCode";

const Admin = () => {
  let navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const { currentUser } = useAuth();
  const [showAdmin, setShowAdmin] = useState(false);
  const [alertType,setAlertType]=useState('')
  const [alertMessage,setAlertMessage]=useState('')


  useEffect(() => {
    if (currentUser) {
      setShowAdmin(true);
    } else {
      setShowAdmin(false);
      navigate("/");
    }
  }, []);

  return (
    <>
      {showAdmin && (
        <>
          <Navbar />
          {showAlert?<Alert  message={alertMessage} setShowAlert={setShowAlert}/>:null}

          <Products setShowAlert={setShowAlert} setAlertMessage={setAlertMessage}/>
          <AddProductModal setShowAlert={setShowAlert} setAlertMessage={setAlertMessage} />
          <AddVariantModal />
          <Orders />
          <PromoCode/>
         
        </>
      )}
    </>
  );
};

export default Admin;
